import React, { createContext, useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { StoreContext } from './StoreContext.js';

export const RecommendationContext = createContext();

const RecommendationProvider = ({ children }) => {
  const { url, bev_list, token } = useContext(StoreContext);
  const [recommendation, setRecommendation] = useState(null);

  useEffect(() => {
    const fetchUserOrders = async () => {
      if (!token || !url) return;

      try {
        console.log('Fetching user orders with URL:', url); // Debug logging
        const response = await axios.get(url + "/api/order/listorders",{}, { headers: { token } });
        const orders = response.data.data;

        if (orders && orders.length > 0) {
          const mostRecentOrder = orders[0];
          const recentSugarLevel = mostRecentOrder.items[0].sugar;
          const differentSugarBevs = bev_list.filter(bev => bev.sugar < recentSugarLevel);

          if (differentSugarBevs.length > 0) {
            const recommendedBev = differentSugarBevs[Math.floor(Math.random() * differentSugarBevs.length)];
            setRecommendation(recommendedBev);
          } else {
            setRecommendation(null);
          }
        } else {
          setRecommendation(null);
        }
      } catch (error) {
        console.error('Error fetching user orders:', error);
        setRecommendation(null);
      }
    };

    fetchUserOrders();
  }, [token, url, bev_list]);

  return (
    <RecommendationContext.Provider value={{ recommendation, setRecommendation }}>
      {children}
    </RecommendationContext.Provider>
  );
};

export default RecommendationProvider;
